import { render, staticRenderFns } from "./PaymentBlocked.vue?vue&type=template&id=a2d2c178&scoped=true"
import script from "./PaymentBlocked.vue?vue&type=script&lang=js"
export * from "./PaymentBlocked.vue?vue&type=script&lang=js"
import style0 from "./PaymentBlocked.vue?vue&type=style&index=0&id=a2d2c178&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d2c178",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2d2c178')) {
      api.createRecord('a2d2c178', component.options)
    } else {
      api.reload('a2d2c178', component.options)
    }
    module.hot.accept("./PaymentBlocked.vue?vue&type=template&id=a2d2c178&scoped=true", function () {
      api.rerender('a2d2c178', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/payment-regulation/PaymentBlocked.vue"
export default component.exports